import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../Contexts/GlobalContext';
import useGuiTranslations from './MultiLanguage/useGuiTranslations';
import '../Styles/Header.scss';

export default function BreadCrumb (props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [translateGui] = useGuiTranslations();

    return (
        <div className="header__location">
              <span className="breadcrumb1 ilk-harf-buyuk"> {translateGui(globalContext.globalState.menuLocation.b)}</span>
              <span className="breadcrumb2">
                <span className="inline-block ilk-harf-buyuk" style={{display:'none'}}>
                  {translateGui(globalContext.globalState.menuLocation.a) + ' > '}
                </span>
                <span className={classes.root} >
                  {translateGui(globalContext.globalState.menuLocation.b)}
                </span>
              </span>

            </div>
    )
}

const useStyles = makeStyles({
    root: {"paddingLeft":"3px","fontSize":"1.1rem",
    "fontWeight":"500","borderBottom":"1px solid #dadada",
    "color":"#615f5f","width":"100%","paddingBottom":"5px",
    textTransform: 'capitalize',
  }
});